import { createAction } from '@reduxjs/toolkit';
import { AccountAssetsBalance } from '../../api';

export const fetchPortfolioAssets = {
  pending: createAction('portfolioAssets/fetchPortfolioAssets/pending'),
  resolved: createAction<{ account: string; items: AccountAssetsBalance[] }>('portfolioAssets/fetchPortfolioAssets/resolved'),
  rejected: createAction('portfolioAssets/fetchPortfolioAssets/rejected'),
};
